<template>
  <zt-modal
    :active="modalConfirm.active"
    title="Personalización de email"
    @close="$emit('closeDialog')"
    max-width="600px"
  >
    <template>
      <div class="flex items-center px-10 py-16">
        <div
          class="warning-icon flex flex-none items-center justify-center mr-16"
        >
          <zt-icon name="exclamation-triangle" />
        </div>
        <div>
          <p class="text-zt-lg">
            {{modalConfirm.text}}
          </p>
          <p v-if="modalConfirm.caption" class="text-zt-base mt-4">
            {{modalConfirm.caption}}
          </p>
        </div>
      </div>
    </template>

    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-center lg:justify-end items-center p-4"
      >
        <zt-button
          outlined
          data-vs-button="no-notifications"
          class="mr-1 text-primary-200"
         @click="$emit('closeDialog')"
        >
        {{modalConfirm.cancelBtn}}
        </zt-button>

        <zt-button data-vs-button="with-notifications" @click="$emit('confirm')"
          >{{modalConfirm.confirmBtn}}</zt-button
        >
      </div>
    </template>
  </zt-modal>
</template>

<script>
export default {
  name: "ModalConfirm",
  props:{
    modalConfirm: Object
  }
}

</script>

<style scoped>
.warning-icon {
  width: 70px;
  height: 70px;

  border-radius: 50%;
  border: 2px solid #fb8c00;
  color: #fb8c00;
}
.warning-icon i {
  font-size: 2.438rem;
}
.zt-modal-footer {
  background-color: #eee;
}
::v-deep .zt-button.text-primary-200 {
  color: #4f41a3 !important;
  background-color: #eee;
}
::v-deep .zt-modal.rounded {
  border-radius: 0.375rem !important;
}
</style>
